<template>
  <CircleChart
    :score="(score / maxValue) * 10"
    :scoreText="score"
    :name="name"
    :dashValue="270"
    :circleRay="88.5"
    :scorePosition="90"
    :rotate="'rotate(182,100,100)'"
    :grad="{ x1: '-80%', y1: '30%', x2: '-90%', y2: '100%' }"
  >
    <template v-slot:default="slotProps">
      <text x="7" y="115" text-anchor="start" transform="matrix(1 0 0 1 0 0)"
        >0</text
      >

      <text
        x="100"
        y="115"
        text-anchor="middle"
        transform="matrix(1 0 0 1 0 0)"
        >{{ slotProps.label }}</text
      >

      <text x="192" y="115" text-anchor="end" transform="matrix(1 0 0 1 0 0)">{{
        maxValue
      }}</text>
    </template>
  </CircleChart>
</template>

<script>
import CircleChart from '@/components/Charts/CircleChart.vue'

export default {
  components: { CircleChart },

  props: {
    score: { type: Number, default: undefined },
    name: { type: String, default: '' },
    maxValue: { type: Number, default: 0 },
  },
}
</script>
